<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ grocer.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <GrocerTabLinks />

                    <IntegrationNotice
                        :has-integration="!!grocer.alias"
                        :is-business-admin="!adminOnly"
                    />

                    <div class="flex mt-2">
                        <ProductFinder
                            business_type="grocer"
                            :business_id="$route.params.id"
                            @select="selectGoods"
                        />
                    </div>
                    <div class="flex mt-2">
                        <CButton
                            v-if="(!grocer.alias && adminOnly) || (!grocer.alias && !adminOnly) || (grocer.alias && adminOnly)" 
                            color="primary" 
                            @click="create"> 
                            Создать 
                        </CButton>
                    </div>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <table class="table">
                            <thead>
                                <th class="d-md-block d-none"><input v-model="areTableItemsDraggable" type="checkbox" /></th>
                                <th>Приоритет</th>
                                <th>Название</th>
                                <th>Цена</th>
                                <th></th>
                            </thead>
                            <component
                                :is="!isMobile && areTableItemsDraggable ? 'draggable': 'tbody'"
                                v-model="goodsList"
                                tag="tbody">
                                <tr v-for="goods in goodsList" :key="goods.id">
                                    <td class="d-md-block d-none">
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="cursor-pointer"
                                        />
                                    </td>
                                    <td>
                                        {{ goods.priority }}
                                    </td>
                                    <td>
                                        <CLink
                                            :to="`/grocers/${grocer.id}/goods/${goods.id}`"
                                        >{{ goods.title }}</CLink
                                        >
                                        <span v-if="goods.energetic" 
                                              class="ml-2 badge badge-danger" 
                                              title="Энергетик (18+)">18+</span>
                                    </td>
                                    <td>
                                        <p>{{ goods.price }}</p>
                                        <p class="text-gray-400 text-xs">
                                            {{ goods.weight }} {{ UNITS_ENUM[goods.units] }}
                                        </p>
                                    </td>
                                    <td v-if="(!grocer.alias && adminOnly) || (!grocer.alias && !adminOnly) || (grocer.alias && adminOnly)">
                                        <input
                                            v-model="goods.enabled"
                                            type="checkbox"
                                            @change="updateGoods(goods)"
                                        />
                                    </td>
                                </tr>
                            </component>
                        </table>
                        <CPagination
                            class="mt-4"
                            :active-page.sync="activePage"
                            :pages="totalPages"
                            align="center"
                        />
                    </CRow>
                </CCardBody>
                <CCardFooter v-if="(!grocer.alias && adminOnly) || (!grocer.alias && !adminOnly) || (grocer.alias && adminOnly)">
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save"
                    >Сохранить порядок</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';

    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import IntegrationNotice from '@/components/IntegrationNotice';
    import ProductFinder from '@/components/ProductFinder';
    import { ITEMS_PER_PAGE } from '../../utils/views';
    import { UNITS_ENUM } from '@/utils/units';

    export default {
        name: 'GrocerGoods',

        components: {
            GrocerTabLinks,
            IntegrationNotice,
            draggable,
            ProductFinder,
        },

        data() {
            return {
                grocer: {},
                goodsList: [],
                totalPages: 0,
                areTableItemsDraggable: true,
                UNITS_ENUM
            };
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
            isMobile() {
                return window.innerWidth < 768
            }
        },

        watch: {
            activePage: 'fetchList',
        },

        async created() {
            this.fetchEntity();
            this.fetchList();
        },

        icons: {
            cilCursorMove,
        },

        methods: {
            async fetchList() {
                const id = this.$route.params.id;
                const params = { page: this.activePage };
                Vue.axios
                    .get('/grocers/' + id + '/goods', { params })
                    .then(resp => {
                        this.goodsList = resp.data.results;
                        this.totalPages = parseInt(resp.data.total / ITEMS_PER_PAGE) + 1;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            async fetchEntity() {
                const id = this.$route.params.id;
                Vue.axios
                    .get('/grocers/' + id)
                    .then(resp => {
                        this.grocer = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.goodsList.forEach(goods => {
                    reorder.push({
                        id: goods.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/grocers/' + this.grocer.id + '/goods/reorder', {
                        reorder: reorder,
                    })
                    .then(resp => {
                        this.$router.push('/grocers/' + this.grocer.id);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения порядка товаров. ' + err);
                    });
            },

            create() {
                this.$router.push('/grocers/' + this.grocer.id + '/goods/create');
            },

            selectGoods(id) {
                this.$router.push('/grocers/' + this.grocer.id + '/goods/' + id);
            },
            updateGoods(good) {
                Vue.axios.put('/grocers/' + this.grocer.id + '/goods/' + good.id, good)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
        },
    };
</script>
<style lang="scss" scoped>
.table {
    tr {
        td {
            padding: .2rem .75rem;
            vertical-align: middle;

            &:nth-child(2) {
                max-width: 30vw;
            }
        }
    }
}
</style>
